var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded)?_c('div',[_c('router-view')],1):_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }